
<div class="error-message-container">
    <app-error-message  *ngIf="message!=''" [message]="message"></app-error-message>
</div>

<h2>כניסה עם קוד חד פעמי לנייד</h2>
<div class="wrapper">
    <p>
        עבור משתמשים שמספר הטלפון הנייד שלהם מעודכן במערכות משרד החינוך
    </p>
    <form [formGroup]="idCardForm" id="idCardForm">   
        <div class="idCard">
            <label for="idCard" class="eds-input-label">מספר תעודת הזהות שלך</label>
            <div class='inputs-container'>
                <input id="idCard" autofocus autocomplete="off" formControlName="idCard"  class="idCard" maxlength="9" type="text" pInputText appOnlynumber (input) = "message!='' && resetMassage(); isValidFormSubmitted = false" (keydown)="handleIdCardKeyDown($event)"
                [ngClass]="(isValidFormSubmitted && (idCard.errors?.required || idCard.errors?.israelid)) ? 'inputInvalid' : 'inputNotInvalid'">
                <p-message style="right: 0;" severity="error" text="מבנה מספר הזהות אינו תקין" *ngIf=" isValidFormSubmitted && idCard.errors?.israelid">
                </p-message>
                    <p-message style="right: 0;" severity="error" text="שדה חובה"  *ngIf="isValidFormSubmitted && idCard.errors?.required">
                    </p-message>
                  
            </div>
            <label id="phone" (click)="focuseDropdwon()" class="eds-input-label">מספר הטלפון הנייד שלך</label>
            <div class='inputs-container'>                                      
                <div class="phone-input">
                    
                    <input id="phoneNumber" autocomplete="off" aria-label="הזן מספר טלפון" formControlName="phoneNumber" maxlength="7" type="text" pInputText appOnlynumber [style]="{'width': '143px', 'height': '38px'}" (input) = "message!='' && resetMassage(); isValidFormSubmitted = false"
                    (input)="isValidFormSubmittedPhone = false" (keydown)="handlePhoneNumberKeyDown($event)" 
                    [ngClass]="(isValidFormSubmitted  && (phoneNumber.errors?.required || (phoneNumber.errors?.minlength || phoneNumber.errors?.maxlength)))? 'inputInvalid' : 'inputNotInvalid'">                        
                    <p-message class="requirePhoneNumber" severity="error" text="שדה חובה"  *ngIf="isValidFormSubmitted &&  phoneNumber.errors?.required" >
                    </p-message>
                    <p-message class="requirePhoneNumber" severity="error" text="מספר טלפון נייד לא חוקי"  *ngIf="(phoneNumber.errors?.minlength || phoneNumber.errors?.maxlength) && isValidFormSubmitted">
                    </p-message>
                    <select id="phoneCodeDrop"  for="phone" formControlName="phoneCode"  placeholder=" " aria-label="בחר קידומת" [ngClass]="{inputInvalid:isValidFormSubmitted && phoneCode.errors?.required || isValidFormSubmittedPhone}" class="dropdownDiv" [style]="{'width': '82px', 'height': '40px'}" (keydown)="handleDropdownKeydown($event)" (click) = "handleDropdownClick()" >
                        <option  for="phone" *ngFor="let option of phoneCodeOptions" [value]="option.phoneCode"  optionLabel="phoneCode"> <span class="arrow-up"></span>{{ option.phoneCode }}</option>
                    </select>

<!--                       
                    <div #dropdown id="phoneCodeDrop" aria-label="בחר קידומת" for="phone" [ngClass]="{inputInvalid:isValidFormSubmitted && phoneCode.errors?.required || isValidFormSubmittedPhone}" class="dropdownDiv" [style]="{'width': '82px', 'height': '40px'}" (keydown)="handleDropdownKeydown($event)" >
                        <p-dropdown id="phoneCodeDrop" aria-label="בחר קידומת" 
                         #dropdown1 [options]="phoneCodeOptions" formControlName="phoneCode"   placeholder=" " (click) = "handleDropdownClick()" (keypress)="handleDropdownKeydown($event)"
                            optionLabel="phoneCode" >
                        </p-dropdown>
                    </div> -->
                </div>
                <!-- <p-message severity="error" text=" מספר טלפון נייד לא חוקי"
                 *ngIf="(phoneNumber.errors?.minlength || phoneNumber.errors?.maxlength) && phoneNumber.touched || isValidFormSubmittedPhone"></p-message> -->
                <p-message style="right: 0;" severity="error" text="שדה חובה"  *ngIf="isValidFormSubmitted &&  phoneCode.errors?.required" >
                </p-message>
           
               </div>
         
               

              
            <div class="container-button container-fluid">
                <p-button #submitButton type="submit" label="שלחו לי קוד"  (onClick)="CaptchaNeeded ? captchaRef.execute() : onSubmit()" (keydown)="KeyDownButton($event)" >
                </p-button>
  
                <span class="cesher-phone">הודעה קולית תישלח לטלפונים כשרים</span>
            </div>
        </div>
        <re-captcha #captchaRef="reCaptcha" (resolved)="$event && onSubmit($event)" siteKey="{{this.sitekey}}" size="invisible" ></re-captcha> 
    </form>
    <div class="container-link">
    <a target='_blank' rel="noopener noreferrer" href={{this.updatePhone}} class="update-phone">
        לעדכון טלפון נייד ודוא"ל
    </a>
    </div>

    <app-tooltip-help *ngIf="showPopupCard" (closePopup)="closePopup()" [contect]="HTMLContent"
        [title]="'מספר הזהות שלך'">
    </app-tooltip-help>
</div>

<app-loader *ngIf="loader"  [text]="'המערכת בודקת את הנתונים'"></app-loader>


